import { gql } from "graphql-request";

// get the variant images, personalisation metafields and swatches
export const GET_CUSTOM_PRODUCT_DATA = (handle: string, optionValues: string[]) => gql`
  query getCustomProductData {
    product: product(handle: "${handle}") {
      personalisationTop: metafield(namespace: "custom", key: "personalisation_top") {
        value
      }
      personalisationLeft: metafield(namespace: "custom", key: "personalisation_left") {
        value
      }
      variantImages: variants(first: 100) {
        nodes {
          id
          image {
            altText
            url
          }
        }
      }
    },  
    ${optionValues?.length ? optionValues.map(value => {
      const handle = value.toLowerCase().replace(/ /g, "-")
      return `
        ${handle.replace(/-/g, "_")}: metaobject(handle: { handle: "${handle}", type: "colour_selector"}) {
          fields {
            key
            value
            reference {
              ... on MediaImage {
                image {
                  url
                }
              }
            }
          }
        }
      `
    }) : ""}
  }
`;